// /opt/isp_erp/frontend/src/components/tickets/VinetaBuscador.jsx
import React from 'react';
import { Autocomplete, Box, Chip, CircularProgress, TextField, Typography } from '@mui/material';

const esTuya = (v) => v.origen === 'ASIGNADO_A_TI' || v.asignada_a_tecnico === true;

/**
 * Selector de viñeta con buscador: escribe parte del serial o del nombre para filtrar.
 * value = serial elegido ('' si ninguno). onChange(serial | '').
 */
const VinetaBuscador = ({ opciones = [], value, onChange, label = 'Viñeta', vacio = 'Buscar viñeta...', disabled = false, loading = false }) => {
  const seleccionada = opciones.find((v) => v.serial === value) || null;
  return (
    <Autocomplete
      fullWidth
      size="small"
      options={opciones}
      value={seleccionada}
      disabled={disabled}
      loading={loading}
      onChange={(_, v) => onChange(v ? v.serial : '')}
      getOptionLabel={(v) => (v ? `${v.serial}${v.nombre ? ` - ${v.nombre}` : ''}` : '')}
      isOptionEqualToValue={(a, b) => a.serial === b.serial}
      noOptionsText="No hay viñetas que coincidan"
      renderOption={(props, v) => (
        <li {...props} key={v.id || v.serial}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, width: '100%' }}>
            <Typography variant="body2" sx={{ flexGrow: 1 }}>{v.serial}{v.nombre ? ` - ${v.nombre}` : ''}</Typography>
            <Chip size="small" variant="outlined" color={esTuya(v) ? 'success' : 'default'} label={esTuya(v) ? 'Tuya' : 'Bodega'} />
          </Box>
        </li>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={vacio}
          InputProps={{
            ...params.InputProps,
            endAdornment: (<>{loading ? <CircularProgress size={16} /> : null}{params.InputProps.endAdornment}</>),
          }}
        />
      )}
    />
  );
};

export default VinetaBuscador;
